<template>
  <transition name="modal">
    <div class="modal-mask">
      <div id='modalContainer'>
        <div class='modal-header'>
          <h2>
            {{ appModalData.title }}
          </h2>
        </div>
        <div class='modal-body'>
          <div class="table-container">
            <table class="table is-striped is-narrow">
              <tr><th>ID</th><th>Year</th><th>Event</th></tr>
              <tr><td>A</td><td>2004</td><td>MMR: What they didn't tell you, Dispatches</td></tr>
              <tr><td>B</td><td>2004</td><td>Untouchables, written by Michael Gillard and Laurie Flynn</td></tr>
              <tr><td>C</td><td>2004</td><td>Terror Sting, Mazher Mahmood, News of the World</td></tr>
              <tr><td>D</td><td>2006</td><td>Extraordinary Rendition, Stephen Grey</td></tr>
              <tr><td>E</td><td>2006</td><td>Panorama Undercover: Football's Dirty Secrets</td></tr>
              <tr><td>F</td><td>2007</td><td>Dispatches, Undercover Mosque</td></tr>
              <tr><td>G</td><td>2008</td><td>Panorama, What happened to Baby P?</td></tr>
              <tr><td>H</td><td>2009</td><td>Daily Telegraph, The Expenses File (MPs expenses)</td></tr>
              <tr><td>I</td><td>2009</td><td>Dispatches, Inside Britain's Israel Lobby (Peter Oborne)</td></tr>
              <tr><td>J</td><td>2010</td><td>David Leigh and Rob Evan (Guardian), Corruption at BAE Systems</td></tr>
            </table>
          </div>
        </div>
        <div class='modal-footer'>
          <button type="button" class="close-btn button" @click="close">{{appModalData.closeButtonText}}</button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>



    export default {
        name: "AppModal",
        props: {
            appModalData: {
                title: '',
                closeButtonText: ''
            },
            userId: ''
        },
        methods: {
            close (){
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  #modalContainer {
    position: absolute;
    z-index: 100;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 80%;
    height: 65%;
    background: #FFF;
    border-radius: 25px;
  }


  .close-btn {
    background-color: #fff;
  }

  .modal-body {
    padding: 30px;
  }

  .modal-body p {
    padding: 5px;
  }

  .modal-footer{
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 50px;
    text-align: center;
  }

</style>
